import { DenialOfCreditService } from '../services/denialOfCreditService';
import { observable, makeObservable, flow } from 'mobx';
import { GlobalStore } from '@roc/client-portal-shared/stores';
import { DenialOfCreditRequestStore } from '../modules/denialOfCredit/denialOfCreditForm/stores/denialOfCreditRequestStore';


export class DenialOfCreditStore {
  private globalStore: GlobalStore;
  denialOfCreditRequestStore: DenialOfCreditRequestStore;
  denialOfCreditService: DenialOfCreditService;
  isDeclined: boolean;
  requestSubmitted: boolean;
  success: boolean;
  denialExist: boolean;

  constructor(globalStore: GlobalStore) {
    this.denialOfCreditService = new DenialOfCreditService();
    this.denialOfCreditRequestStore = new DenialOfCreditRequestStore(globalStore);
    this.isDeclined = null;

    makeObservable(this, {
      isDeclined: observable,
      getDenialOfCredit: flow,
      requestSubmitted: observable,
      success: observable,
      denialExist: observable,
    });
  }

  *getDenialOfCredit(loanId: string) {
    try {
      const {
        data: response,
      } = yield this.denialOfCreditService.sendDenialOfCredit(
        loanId,
      );
      this.isDeclined = response;
      if (this.isDeclined){
        const{
          data: response,
        } = yield this.denialOfCreditService.checkDenialOfCreditExist(loanId);
        this.denialExist = response;
      }
    }
    catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while sending request.',
      });
    }
  }

}

export default DenialOfCreditStore;
